import { useEffect } from 'react';
import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TituloH3 = ({ classes, text }) => {
  useEffect(() => {
    const titulosh3 = gsap.utils.toArray('.title-h3-js');

    titulosh3.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          y: 10
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'top bottom'
            // markers: true
          },
          autoAlpha: 1,
          y: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  return <h3 className={cn(classes, 'title-h3-js')}>{text}</h3>;
};
export default TituloH3;
